import type { ReactNode } from 'react';
import { cn } from './cn';

/** Toggleable chip with an optional image (technology chips, FR-TECH-007). */
export function Chip({
  selected,
  onToggle,
  image,
  children,
  disabled,
}: {
  selected: boolean;
  onToggle?: () => void;
  image?: ReactNode;
  children: ReactNode;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled || !onToggle}
      onClick={onToggle}
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors disabled:cursor-default',
        selected
          ? 'border-brand-500 bg-brand-50 font-medium text-brand-700'
          : 'border-border bg-surface text-ink-muted',
        onToggle && !disabled && 'hover:border-brand-200',
      )}
    >
      {image}
      {children}
    </button>
  );
}
